import React from 'react'

import ChatMessageSuggestion from '@components/chat-message-suggestion/chat-message-suggestion.component'

import useStyles from './chat-message-suggestions.style'

const ChatMessageSuggestions = (props) => {
  const classes = useStyles(props)

  const { messageGuid, messageId, onClick, pressedSuggestionIndex = -1, suggestions } = props

  const hasSuggestions = suggestions && suggestions.length > 0

  const showSuggestions = hasSuggestions && !suggestions.some(suggestion => suggestion.reply.text === 'response-hidden')

  const isGroupLocked = pressedSuggestionIndex !== -1

  return showSuggestions ? (
    <div className={classes.suggestionsContainer}>
      {suggestions.map((suggestion, index) => (
        <ChatMessageSuggestion
          key={`suggestion-${index}`}
          disabled={isGroupLocked}
          index={index}
          messageGuid={messageGuid}
          messageId={messageId}
          onClick={onClick}
          pressed={index === pressedSuggestionIndex}
          suggestion={suggestion}
        />
      ))}
    </div>
  ) : null
}

export default ChatMessageSuggestions
